import React from "react";
import Mainscreen from "../src/MainScreen/front.js"

function App() {
  return (
    <div>
      <Mainscreen/>
    </div>
  )
}

export default App